module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADJSURBVHgB7dbhDYIwEIbhr8YBcANHcARG0A0YpRs5AqPABrJBvYYzqY1AG4+WH/ck94e05A0EUkAppfI55540PQScIeMGISccjAZt0aAtSUH0Sd/9Z01zRSa/h/d2KetTn1BD09JkRfHanvfKoptbNxviKL42xDF83bPYw1JUHFQkZi0qDCoasxT1CaoSE0R1QdSLp07Mj6iQRU1RlMURuPnH2UIVYLYW0Kvwp8EGMkZjzIg/gxzkTBR0WVuQcqZ+QO4JTVBKqW9vEssMrRhOgW4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/downicon.png
// module id = F6qk
// module chunks = 0